import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import moment, {Moment} from 'moment';
import {QueryField} from '../../../../../core/definitions/extended-search/query-field';
import { getDateFormat } from "../../../../../object-edit/edit-field-date-picker/edit-field-date-picker.component";
import {MAT_DATE_FORMATS} from "@angular/material/core";
import {SettingsService} from "../../../../../core/settings.service";

@Component({
    selector: 'app-date-input',
    templateUrl: './date-input.component.html',
    styleUrls: ['./date-input.component.scss'],
    providers: [
      {
        provide: MAT_DATE_FORMATS,
        useFactory: getDateFormat,
        deps: [SettingsService]
      }
    ],
    standalone: false
})
export class DateInputComponent implements OnChanges {

  @Input() field: QueryField;
  @Input() label: string;
  @Input() fromDatePlaceholder: string;
  @Input() toDatePlaceholder: string;

  @Output() public readonly searchValueChanged: EventEmitter<string | null>;

  fromDate: Moment;
  toDate: Moment;

  constructor() {
    this.searchValueChanged = new EventEmitter<string | null>();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('field')) {
      this.field = changes.field.currentValue;
      const {fromDate, toDate} = this.field?.inputOptions?.additionalData || {};
      if (fromDate) {
        this.fromDate = moment(fromDate);
      }
      if (toDate) {
        this.toDate = moment(toDate);
      }
    }
  }

  dateChanged(): void {
    const fromDate = this.fromDate?.toISOString() || '*';
    const toDate = this.toDate?.toISOString() || '*';
    this.field.inputOptions.additionalData = {fromDate, toDate};
    this.searchValueChanged.emit(`[${fromDate} TO ${toDate}]`);
  }

}
